import PupInfo from './pup-info.svg';
import FeedingGuidelines from './feeding-guidelines.svg';
import ChangeRecipes from './change-recipes.svg';
import DeliveryTruck from './delivery-truck.svg';
import BoxFrequency from './box-frequency.svg';
import FeedingPortion from './feeding-portion.svg';

export const features = [
  {
    text: `Update your pup's info`,
    icon: PupInfo.src,
    alt: `Update your pup's info`,
  },
  {
    text: `View feeding guidelines`,
    icon: FeedingGuidelines.src,
    alt: `View feeding guidelines`,
  },
  {
    text: `Change recipes`,
    icon: ChangeRecipes.src,
    alt: `Change recipes`,
  },
  {
    text: `Modify delivery date`,
    icon: DeliveryTruck.src,
    alt: `Modify delivery date`,
  },
  {
    text: `Edit box frequency`,
    icon: BoxFrequency.src,
    alt: `Edit box frequency`,
  },
  {
    text: `Adjust feeding portion`,
    icon: FeedingPortion.src,
    alt: `Adjust feeding portion`,
  },
];
export const headline = `You're in control`;
export const description = `Your account page lets you stay on top of your subscription.`;
export const buttonText = `View Account`;
export const viewAccountURL = `/account/`;
